import { gql } from "@apollo/client";
import { lensCompoundIdFragment } from "./lensCompoundIdFragment";

export const lensDetailsConnectionFragment = gql`
    fragment LensDetailsConnection on GroupLensConnection {
        connectionId
        priority
        vendorData {
            key
            value
        }
        group {
            totalNumLenses
            name
            id
        }
        lens {
            removed
            ...LensCompoundId
        }
        schedule {
            scheduleStart {
                seconds
            }
            scheduleEnd {
                seconds
            }
            useClientTimezone
        }
    }
    ${lensCompoundIdFragment}
`;
